import { Store, BarChart3, Grid3X3, Bug, Link2, LogOut, User, Loader2, Info } from 'lucide-react';

export default function NavigationBar({ currentView, setCurrentView, user, logout, queueStatus, currentlyValidatingStore }) {
    return (
        <nav className="navbar">
            <div className="navbar-container">
                {/* Brand */}
                <div className="navbar-brand">
                    <div className="navbar-logo">
                        <Store size={28} />
                    </div>
                    <span className="navbar-title">LP Proofer</span>
                </div>

                {/* Navigation Items */}
                <div className="navbar-nav">
                    <button
                        onClick={() => setCurrentView('stores')}
                        className={`navbar-item ${currentView === 'stores' ? 'active' : ''}`}
                    >
                        <Grid3X3 size={18} />
                        <span>Overview</span>
                    </button>
                    <button
                        onClick={() => setCurrentView('dashboard')}
                        className={`navbar-item ${currentView === 'dashboard' ? 'active' : ''}`}
                    >
                        <BarChart3 size={18} />
                        <span>Dashboard</span>
                    </button>
                    <button
                        onClick={() => setCurrentView('urlcheck')}
                        className={`navbar-item ${currentView === 'urlcheck' ? 'active' : ''}`}
                    >
                        <Link2 size={18} />
                        <span>URL Check</span>
                    </button>
                    <button
                        onClick={() => setCurrentView('debug')}
                        className={`navbar-item ${currentView === 'debug' ? 'active' : ''}`}
                    >
                        <Bug size={18} />
                        <span>Debug</span>
                    </button>
                    <button
                        onClick={() => setCurrentView('version')}
                        className={`navbar-item ${currentView === 'version' ? 'active' : ''}`}
                    >
                        <Info size={18} />
                        <span>Version</span>
                    </button>
                </div>

                {/* Global Validation Status Indicator */}
                {queueStatus.isProcessing && (
                    <div className="navbar-status">
                        <div className="flex items-center gap-2 px-3 py-2 rounded-lg bg-blue-500/20 border border-blue-400/30">
                            <Loader2 size={16} className="text-blue-600 animate-spin" />
                            <div className="flex flex-col">
                                <span className="text-xs font-semibold text-blue-700">
                                    Validating {currentlyValidatingStore || '...'}
                                </span>
                                {queueStatus.queueLength > 0 && (
                                    <span className="text-xs text-blue-600">
                                        {queueStatus.queueLength} in queue
                                    </span>
                                )}
                            </div>
                        </div>
                    </div>
                )}

                {/* User Menu */}
                <div className="navbar-user">
                    <div className="flex items-center gap-2 px-3 py-2 rounded-lg" style={{ backgroundColor: 'rgba(255, 255, 255, 0.1)' }}>
                        <User size={18} color="white" />
                        <span className="text-white text-sm font-medium">{user?.username || user?.signInDetails?.loginId || 'User'}</span>
                    </div>
                    <button
                        onClick={logout}
                        className="navbar-item hover:bg-red-500/20"
                        title="Logout"
                    >
                        <LogOut size={18} />
                        <span>Logout</span>
                    </button>
                </div>
            </div>
        </nav>
    );
}
